const breakpoints = ["480px", "600px", "768px", "992px", "1280px", "1440px"];
breakpoints.xs = breakpoints[0];
breakpoints.sm = breakpoints[1];
breakpoints.md = breakpoints[2];
breakpoints.lg = breakpoints[3];
breakpoints.xl = breakpoints[4];
breakpoints["2xl"] = breakpoints[5];

export { breakpoints };
